/**
 * Copyright (c) 2024 Epinics (PVT) LTD
 * All Rights Reserved.
 * <p>
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * <p>
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * <p>
 */
import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

// Redux
import { sampleAction } from "../../../actions";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const StepTwoForm = ({
  step,
  setStep,
  formValuesStepTwo,
  formErrorsStepTwo,
  isValidFormStepTwo,
  validateFormStepTwo,
  handleOnChangeStepTwo,
  handleOnClickStepTwo,
  sampleAction,
  layout: {
    sampleState,
    companyName,
    mobileNumber,
    email,
    address,
    password,
    isLoading,
    isSubmittedSuccessfully,
  },
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    if (step < 3) {
      if (step === 2 && isSubmittedSuccessfully) {
        setStep(step + 1);
      }
    }
  }, [isSubmittedSuccessfully]);
  return (
    <div className={styles.mainDiv}>
      <div className={styles.step}>Step 2/3</div>
      <div className={styles.welcome}>Create Your Account Root User</div>
      <div className={styles.subTitle}>Enter a password to Continue</div>
      <div className={styles.formDiv}>
        <div className={styles.row}>
          <div className={styles.formGroup}>
            <label htmlFor="rootUserName">Root User Display Name</label>
            <input
              type="text"
              id="rootUserName"
              value={formValuesStepTwo.rootUserName}
              onChange={e => {
                handleOnChangeStepTwo("rootUserName", e);
              }}
              placeholder="How your name appears on the platform"
            />
          </div>
          <div className={styles.spacer}></div>
          <div className={styles.formGroup}>
            <label className={styles.labelTitle} htmlFor="rootUserUsername">
              Root Login Username <span>*</span>
            </label>
            <input
              type="text"
              id="rootUserUsername"
              value={formValuesStepTwo.rootUserUsername}
              placeholder="Used for login"
              onChange={e => {
                handleOnChangeStepTwo("rootUserUsername", e);
              }}
            />
            {formErrorsStepTwo.rootUserUsername && (
              <div className={styles.error}>
                {formErrorsStepTwo.rootUserUsername}
              </div>
            )}
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.formGroup}>
            <label className={styles.labelTitle} htmlFor="rootUserEmail">
              Root User Email
            </label>
            <input
              type="text"
              id="rootUserEmail"
              placeholder="xxx@mail.com"
              value={
                formValuesStepTwo.rootUserEmail === null
                  ? email
                  : formValuesStepTwo.rootUserEmail
              }
              onChange={e => {
                handleOnChangeStepTwo("rootUserEmail", e);
              }}
            />
          </div>
          <div className={styles.spacer}></div>
          <div className={styles.formGroup}>
            <label className={styles.labelTitle} htmlFor="rootUserMobileNumber">
              Root User Mobile Number
            </label>
            <input
              type="text"
              id="rootUserMobileNumber"
              value={
                formValuesStepTwo.rootUserMobileNumber === null
                  ? mobileNumber
                  : formValuesStepTwo.rootUserMobileNumber
              }
              // placeholder={mobileNumber ? `Default: ${mobileNumber}` : ""}
              onChange={e => {
                handleOnChangeStepTwo("rootUserMobileNumber", e);
              }}
            />
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.formGroup}>
            <label className={styles.labelTitle} htmlFor="password">
              Password <span>*</span>
            </label>
            <div className={styles.passwordWrapper}>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={formValuesStepTwo.password}
                onChange={e => {
                  handleOnChangeStepTwo("password", e);
                }}
              />
              <span
                className={styles.eyeIcon}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
              </span>
            </div>
            {formErrorsStepTwo.password && (
              <div className={styles.error}>{formErrorsStepTwo.password}</div>
            )}
          </div>
          <div className={styles.spacer}></div>
          <div className={styles.formGroup}>
            <label className={styles.labelTitle} htmlFor="confirmPassword">
              Confirm Password <span>*</span>
            </label>
            <div className={styles.passwordWrapper}>
              <input
                type={showConfirmPassword ? "text" : "password"}
                id="confirmPassword"
                value={formValuesStepTwo.confirmPassword}
                onChange={e => {
                  handleOnChangeStepTwo("confirmPassword", e);
                }}
              />
              <span
                className={styles.eyeIcon}
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? (
                  <AiOutlineEyeInvisible />
                ) : (
                  <AiOutlineEye />
                )}
              </span>
            </div>
            {formErrorsStepTwo.confirmPassword && (
              <div className={styles.error}>
                {formErrorsStepTwo.confirmPassword}
              </div>
            )}
          </div>
        </div>

        <div className={styles.desc}>
          <span className={styles.note}>NOTE:</span> Use the provided username
          and password for the initial setup. These credentials can only be
          changed after the Software setup is complete. Ensure they are securely
          stored until then.
        </div>
      </div>
    </div>
  );
};

StepTwoForm.propTypes = {
  sampleAction: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  layout: state.layoutState,
});

export default connect(mapStateToProps, {
  sampleAction,
})(StepTwoForm);
